import React, { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "features/auth/hooks/useAuth";
import { useAdminFlags } from "hooks/useAdminFlags";
import { FullScreenLoader } from "components/ui/Loader";

interface Props {
  children: ReactNode;
}

const SuperAdminRoute: React.FC<Props> = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const { loading: flagsLoading, isSuperadmin } = useAdminFlags();
  const location = useLocation();

  if (authLoading || flagsLoading) {
    return <FullScreenLoader label="Checking superadmin…" />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isSuperadmin) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};

export default SuperAdminRoute;
